import axios from 'axios';
export const UNIT_PATH = '/api/units';
const STANDARD_OPERATIONS_PATH = '/api/standard-operations';
const UNITS_UPDATE_PATH = 'update';

class BulkUpdateService {
  async postBulkUpdateStandardOperation(bulkStandardOperation) {
    const url = `${STANDARD_OPERATIONS_PATH}`;
    await axios.post(url, bulkStandardOperation);
  }

  async postBulkUpdate(update) {
    const url = `${UNIT_PATH}/${UNITS_UPDATE_PATH} `;
    await axios.put(url, update);
  }
}

export default new BulkUpdateService(); // singleton object
